import {DataService} from "src/app/services/common/data.service";
import {ShopProducts} from "src/app/classes/common/shop-products";
import {Injectable} from "@angular/core";
import {ApiService} from "src/app/services/common/api.service";
import {Invoice} from "src/app/classes/common/invoice";
import {Subject} from "rxjs";
import {ShippingAddress} from "src/app/classes/common/order";
import {InvoiceLine} from "src/app/classes/common/invoiceLine";
import {NavController} from "@ionic/angular";
import {ViewService} from "src/app/services/common/view.service";
import {AuthService} from "src/app/services/common/auth.service";


@Injectable({
  providedIn: 'root'
})
export class ShopService{
  public list_product: (ShopProducts | any)[];
  public organization_list_product: any[];
  public lines_mapping: any[] = [];
  public shop_invoice: Invoice;
  public shipping_address: ShippingAddress = new ShippingAddress();
  public recent_shipping_address: ShippingAddress[] = [];
  public url_terms_of_sales: string;
  public accept_terms_of_sales: boolean = false;

  static setLoader = new Subject<any>();
  static setLoader$ = ShopService.setLoader.asObservable()

  static removeLoader = new Subject<any>();
  static removeLoader$ = ShopService.removeLoader.asObservable()

  public generalLoader: boolean = false;
  public productLoader: any[] = [];
  public invoiceLoader: boolean = false;
  public recapLoader: boolean = false;
  public canFinalize: boolean = false;
  public hasProduct: boolean = false;
  public isLogged: boolean = false;

  /**
   * DEBUG: se true mostra sempre il reminder ignorando il carrello.
   * In produzione lasciare `false`.
   */
  public upsell_debug_force_show: boolean = false;

  /**
   * DEBUG: se true, e nessun accessorio del catalogo matcha i tracker
   * in carrello, restituisce due item stub (Cavo + Magnete) per validare
   * la UI. Lascia false in produzione: i match vengono fatti su
   * `type_trackerGps_associato` dei prodotti reali.
   */
  public upsell_debug_use_stubs: boolean = false;

  /** Tab attiva nello shop (Variation D): 'tracker' | 'accessory'. */
  public selected_tab: 'tracker' | 'accessory' = 'tracker';

  constructor(
    private data: DataService,
    private api: ApiService,
    private navController: NavController,
  ){}

  async inizialize(){
    try{
      await AuthService.isReady()
      await DataService.isGeneralConfig().then(async () => {
        this.list_product = DataService.generalConfig.elenco_prodotti_shop
        this.url_terms_of_sales = DataService.generalConfig.url_terms_of_sales;
        if (AuthService.isLogged){
          this.isLogged = true;
          DataService.isInitialized().then(async ()=>{
            this.organization_list_product = this.data.selOrganization.elenco_prodotti_shop
            await this.getShopInvoice()
            await this.analizeInvoiceLine()
            await this.getRecentOrder()
            await this.manageDisplayPrice()
          })
        }else{
          await this.manageDisplayPrice()
        }
      })

      ViewService.updateView.next(undefined);
    }catch (err){
      console.error(err)
    }
  }

  async clearData(){
    this.recent_shipping_address = []
    this.shop_invoice = undefined
    this.organization_list_product = []
    this.shipping_address = new ShippingAddress()
    await this.manageDisplayPrice()
    await this.analizeInvoiceLine()
  }


  /**
   * Verifico se è presente una shop invoice, altrimenti ne creo una
   */
  async getShopInvoice(invoice?: any, forceInvoiceCreation?: boolean ){
    ShopService.setLoader.next({target: 'invoice'})

    if(invoice){
      this.shop_invoice = this.mapInvoiceLineWithProduct(new Invoice(invoice, {lang: this.data.selOrganization.translate_language}))
      this.canFinalize = this.manageEnableFinalizeShopInvoice()
      ShopService.removeLoader.next({target: 'invoice'})
      return;
    }
    //manage invoice
    if(this.data.selOrganization.last_shop_invoice && !forceInvoiceCreation){
       await this.api.shopGetInvoice(this.data.selOrganization.me._id, this.data.selOrganization.last_shop_invoice).then((res: any)=>{
         if(res.success && res.invoice){
            if(res.invoice.status === 'draft'){
              this.shop_invoice = this.mapInvoiceLineWithProduct(new Invoice(res.invoice,{lang: this.data.selOrganization.translate_language}))
            }else{
              this.createShopInvoice()
            }
         }
       }).catch((err)=>{
         console.error(err)
       })
    }else{
      //non ho trovato l'invoice, devo crearne una
      await this.createShopInvoice()
    }
    this.canFinalize = this.manageEnableFinalizeShopInvoice()
    ShopService.removeLoader.next({target: 'invoice'})
  }

  async createShopInvoice(){
    await this.api.shopCreateInvoice(this.data.selOrganization.me._id).then((res: any)=>{
      console.log(res)
      if(res.success && res.invoice){
        this.shop_invoice = this.mapInvoiceLineWithProduct(new Invoice(res.invoice, {lang: this.data.selOrganization.translate_language}))
      }
    }).catch((err)=>{
      console.error(err)
    })
  }

  /**
   * Scelgo il prezzo da visualizzare per ogni singolo prodotto
   */
  async manageDisplayPrice(){

    if(this.list_product){ // ho un elenco prodotti

      for(let i=0; i<this.list_product.length; i++){

        let custom_price: any;

        if(this.organization_list_product){
          custom_price = Object.values(this.organization_list_product).find(elem => elem.id === this.list_product[i].id);
        }

        if(custom_price){
          this.list_product[i]._is_displayed = custom_price.can_sell;
        }

        //scelgo che prezzo visualizzare per i prodotti rimasti
        for(let product of this.list_product[i].custom_priceId_list){
          if(product.is_default){
            this.list_product[i]._default_price = {price: product.price, price_id: product.price_id}
          }
          if(custom_price && custom_price.price_id === product.price_id){
            // ecco il prezzo custom
            this.list_product[i].price_id = product?.price_id
            this.list_product[i]._price = product?.price
            this.list_product[i]._has_custom_price = true;
          }
        }

        if(!this.list_product[i]._has_custom_price){
          this.list_product[i].price_id = this.list_product[i]._default_price?.price_id
          this.list_product[i]._price = this.list_product[i]._default_price?.price
          this.list_product[i]._has_custom_price = false;
        }

        if(this.list_product[i].type === 3){
          this.list_product[i]._is_displayed = false;
        }

        /* Pre-cache descrizione multilingua come stringa, per evitare
           ripetuti lookup `description[lang]` nei binding del template. */
        const lang = this.data?.selOrganization?.translate_language || 'en';
        const p: any = this.list_product[i];
        const readLang = (field: any) => {
          if(!field) return '';
          if(typeof field === 'string') return field;
          return field[lang] || field['en'] || field['it'] || '';
        };
        p._desc_cached = readLang(p.description);
        p._long_desc_cached = readLang(p.long_description);
        p._short_desc_cached = readLang(p.short_description);
      }
      if(this.list_product.find(elem => elem._is_displayed === true)){
        this.hasProduct = true;
      }else{
        this.hasProduct = false;
      }
    }
    ViewService.updateView.next(undefined);
  }

  /**
   * Analizza l'invoice shop e lega le line con i price id dei prodotti
   */
  async analizeInvoiceLine(){
    if(this.shop_invoice){
      this.lines_mapping = []
      let new_line = []
      //check the line
      for(let line of this.shop_invoice.lines){
        //adesso devo trovare l'id di questa line dentro l'elenco prodotti
        for(let i = 0; i<this.list_product.length; i++){
          for(let j =0; j<this.list_product[i].custom_priceId_list.length; j++){
            if(this.list_product[i].custom_priceId_list[j].price_id === line.price.id){
              new_line[i]={price: line.price.id, quantity: line.quantity, item_id: line.invoice_item}; //mappo le line della fattura l'identificativo dei prodotti
            }
          }
        }
      }
      if(new_line){
        this.lines_mapping = new_line
      }
    }else{
      this.lines_mapping = []
    }
  }

  async addItemToInvoice(price_id){
    try{
      if(price_id){
        let addItem: any = await this.api.shopAddItemToInvoice(this.data.selOrganization.me._id, price_id, 1)
        if(addItem){
          await this.getShopInvoice(addItem.invoice)
          await this.analizeInvoiceLine()
        }else{
          //show error message
          console.error(addItem)
        }
      }
    }catch(err){
      console.error(err)
    }
    return;
  }

  async updateInvoiceItem(invoice_item, quantity){
    try{
      if(invoice_item){
        let addItem:any = await this.api.shopPatchInvoiceItem(this.data.selOrganization.me._id, invoice_item, quantity)
        if(addItem){
          await this.getShopInvoice(addItem.invoice)
          await this.analizeInvoiceLine()
        }else{
          //show error message
          console.error(addItem)
        }
      }
    }catch(err){
      console.error(err)
    }
    return;
  }

  async deleteInvoiceItem(invoice_item){
    try{
      if(invoice_item){
        await this.api.shopDeleteInvoiceItem(this.data.selOrganization.me._id, invoice_item).then(async (res: any)=>{
          await this.getShopInvoice(res.invoice)
          await this.analizeInvoiceLine()
        }).catch((err)=>{
          console.error(err)
        })
      }
    }catch(err){
      console.error(err)
    }
  }

  /**
   * Metodo utilizzato per ottenere gli ordini recenti
   */
  async getRecentOrder(){
    await this.api.shopGetRecentOrder(this.data.selOrganization.me._id, 4).then(async (res: any)=>{
      //alimentare variabile recent Address con gli indirizzi degli orders
      this.recent_shipping_address = []
      if(res.success){
        for(let i=0; i<=res.orders.length; i++){
          if(!res.orders[i]?.shipping_address){
            break;
          }
          for(let j=i+1; j<=res.orders.length - 1; j++){
            //sto analizzando tutti i singoli elementi dell'array
            if(res.orders[j]?.shipping_address && JSON.stringify(res.orders[i].shipping_address) === JSON.stringify(res.orders[j].shipping_address)){
              //rimuovo dall'array l'elemento i
              delete res.orders[i]
              break;
            }
          }
        }

        res.orders.map((elem)=>{
          //è presente, bene allora controllo se è uguale
          this.recent_shipping_address.push(new ShippingAddress(elem.shipping_address));

        })
      }
    })
    .catch((err)=>{
      console.error(err)
    })
  }

  /**
   * Assegnare alle singole line il name e il type di elenco_prodotti
   */
  mapInvoiceLineWithProduct(invoice: Invoice){
    if(this.list_product && invoice.metadata?.type ==='product'){
      let newLines = [];
      for(let item of invoice.lines){
        //devo andare a cercare questo price
        this.list_product.forEach((prodotto, i)=>{
          if(prodotto.custom_priceId_list){
            for(let custom_list of prodotto.custom_priceId_list){
              if(custom_list.price_id === item.price.id){
                newLines.push(new InvoiceLine({...item, ...{prodotto_associato: prodotto}}, {lang: this.data.selOrganization.translate_language}))
              }
            }
          }
        })
      }
      invoice.lines = newLines;
    }
    return invoice
  }

  /**
   * Metodo che gestisce l'attivazione del bottone per proseguire con la finalizzazione dell'ordine
   */
  manageEnableFinalizeShopInvoice(){
    //ottengo la shop invoice
    if(this.shop_invoice?.lines){
      for(let line of this.shop_invoice.lines){
        //1. Quanto aggiunto alla fatture un prodotto con tipo !== da spedizione
        if(line._prodotto_associato?.type !== 3){
          return true;
        }
      }
    }
    return false;
  }

  goToPage(pageName: string){
    this.navController.navigateForward(pageName);
  }

  /**
   * Stato del reminder di upsell mostrato nel Riepilogo (Variation C).
   * Per ogni accessorio compatibile restituisce: `product`, `index` (in
   * `list_product`), `qty` (quantità in carrello, 0 se non aggiunto).
   */
  /* ────── Memoization upsell ──────────────────────────────────────────
     Tutti i metodi chiamati dai template (getUpsellAccessories,
     getInCartCountForTab, showAccessoryNudge) condividono uno "stamp"
     calcolato sui dati reattivi (lines_mapping, _stub_qty, flag debug,
     visibilità prodotti). Quando lo stamp non cambia tra due render
     consecutivi, restituiamo i risultati cachati — array stabili = nessun
     teardown DOM nei *ngFor. */
  private _memoStamp: string = '';
  private _memoUpsell: { product: any; index: number; qty: number }[] | null = null;
  private _memoTrackerCount: number | null = null;
  private _memoAccessoryCount: number | null = null;
  private _memoNudge: boolean | null = null;

  private currentMemoStamp(): string {
    if(!this.list_product) return 'X';
    let s = `${this.list_product.length}`;
    for(let i = 0; i < this.list_product.length; i++){
      const p = this.list_product[i];
      s += `|${p?._is_displayed ? '1' : '0'}:${(p as any)?.type ?? '_'}`;
      const l = this.lines_mapping?.[i];
      if(l) s += `*${l.quantity || 0}`;
    }
    if(this._stub_qty){
      for(const k in this._stub_qty){
        s += `|s${k}:${this._stub_qty[k]}`;
      }
    }
    if(this.upsell_debug_force_show) s += '|F';
    if(this.upsell_debug_use_stubs) s += '|S';
    return s;
  }

  private ensureMemo(){
    const stamp = this.currentMemoStamp();
    if(stamp === this._memoStamp && this._memoUpsell !== null) return;
    this._memoStamp = stamp;
    this._memoUpsell = this._computeUpsellAccessories();
    this._memoTrackerCount = null;
    this._memoAccessoryCount = null;
    this._memoNudge = null;
  }

  getUpsellAccessories(): { product: any; index: number; qty: number }[] {
    this.ensureMemo();
    return this._memoUpsell || [];
  }

  private _computeUpsellAccessories(): { product: any; index: number; qty: number }[] {
    if(!this.list_product || !this.list_product.length) return [];
    if(!this.lines_mapping) return [];

    /* 1. Raccolgo i `type_trackerGps` dei tracker presenti nel carrello. */
    const trackerTypesInCart = new Set<number>();
    for(let i = 0; i < this.list_product.length; i++){
      if(!this.lines_mapping[i]) continue;
      const p = this.list_product[i] as any;
      if(p.type !== 1) continue;
      const t = p.type_trackerGps;
      if(t === undefined || t === null) continue;
      trackerTypesInCart.add(Number(t));
    }

    if(!this.upsell_debug_force_show && !trackerTypesInCart.size) return [];

    /* 2. Match accessori via `type_trackerGps_associato`. */
    const result: { product: any; index: number; qty: number }[] = [];
    for(let i = 0; i < this.list_product.length; i++){
      const p = this.list_product[i] as any;
      if(!p._is_displayed) continue;
      if(p.type !== 2) continue;
      const associations: any[] = Array.isArray(p.type_trackerGps_associato)
        ? p.type_trackerGps_associato
        : [];
      if(!associations.length) continue;
      let matched = this.upsell_debug_force_show;
      if(!matched){
        for(const a of associations){
          const t = a?.type_trackerGps;
          if(t !== undefined && t !== null && trackerTypesInCart.has(Number(t))){ matched = true; break; }
        }
      }
      if(!matched) continue;
      const line = this.lines_mapping[i];
      result.push({ product: p, index: i, qty: line ? Number(line.quantity) || 0 : 0 });
    }

    /* 3. Fallback debug: stubs hardcoded se nessun match e flag attivo. */
    if(!result.length && this.upsell_debug_use_stubs && (trackerTypesInCart.size || this.upsell_debug_force_show)){
      const lang = this.data?.selOrganization?.translate_language || 'en';
      const cavo: any = {
        description: { it: 'Cavo di ricarica', en: 'Charging cable' },
        short_description: { it: 'Alimentazione 12–24V con fusibile, 1,5 m', en: '12–24V power, fused, 1.5 m' },
        price_id: null, url_image: null, _price: 19, _is_stub: true
      };
      const magnete: any = {
        description: { it: 'Magnete', en: 'Magnet' },
        short_description: { it: 'Base al neodimio, tenuta fino a 300 km/h', en: 'Neodymium base, holds up to 300 km/h' },
        price_id: null, url_image: null, _price: 12, _is_stub: true
      };
      cavo._desc_cached = cavo.description[lang] || cavo.description['en'];
      cavo._short_desc_cached = cavo.short_description[lang] || cavo.short_description['en'];
      magnete._desc_cached = magnete.description[lang] || magnete.description['en'];
      magnete._short_desc_cached = magnete.short_description[lang] || magnete.short_description['en'];
      return [
        { product: cavo, index: -1, qty: this._stub_qty[-1] || 0 },
        { product: magnete, index: -2, qty: this._stub_qty[-2] || 0 }
      ];
    }

    return result;
  }

  /** TrackBy per *ngFor sui chip upsell — riusa il DOM tra render. */
  trackByUpsellIndex(_: number, item: any): any {
    return item?.index;
  }

  /** TrackBy per *ngFor sulla lista prodotti dello shop. */
  trackByProductIndex(index: number, p: any): any {
    return p?.id ?? index;
  }

  /** Stato locale per le quantità degli stub in modalità debug. */
  private _stub_qty: { [k: number]: number } = {};

  /** Cambia tab attiva (tracker / accessory). */
  setTab(tab: 'tracker' | 'accessory'){
    this.selected_tab = tab;
    ViewService.updateView.next(undefined);
  }

  /** Tracker = `type === 1`. Accessorio = `type === 2`. Spedizione `type === 3` (mai mostrata nei tab). */
  isProductTracker(p: any): boolean { return p?.type === 1; }
  isProductAccessory(p: any): boolean { return p?.type === 2; }

  /** True se il prodotto fa parte della tab attualmente selezionata. */
  isProductInActiveTab(p: any): boolean {
    if(!p) return false;
    if(p.type === 3) return false;
    return this.selected_tab === 'tracker' ? this.isProductTracker(p) : this.isProductAccessory(p);
  }

  /**
   * Conta i prodotti del tab indicato disponibili per questo cliente
   * (rispetta `_is_displayed`, esclude le spedizioni). Non dipende dal
   * carrello — è il numero di item visibili nella tab. Memoizzato.
   */
  getInCartCountForTab(tab: 'tracker' | 'accessory'): number {
    this.ensureMemo();
    if(tab === 'tracker'){
      if(this._memoTrackerCount !== null) return this._memoTrackerCount;
    } else {
      if(this._memoAccessoryCount !== null) return this._memoAccessoryCount;
    }
    if(!this.list_product){
      if(tab === 'tracker') this._memoTrackerCount = 0; else this._memoAccessoryCount = 0;
      return 0;
    }
    let count = 0;
    for(let i = 0; i < this.list_product.length; i++){
      const p = this.list_product[i] as any;
      if(!p._is_displayed) continue;
      if(p.type === 3) continue;
      if(tab === 'tracker' && p.type === 1) count++;
      else if(tab === 'accessory' && p.type === 2) count++;
    }
    if(tab === 'tracker') this._memoTrackerCount = count; else this._memoAccessoryCount = count;
    return count;
  }

  /**
   * Dato l'index di un prodotto che si vuole eliminare dal carrello,
   * restituisce la lista degli accessori in carrello che resterebbero "orfani"
   * (cioè senza alcun tracker compatibile residuo). Se il prodotto non è un
   * tracker, ritorna lista vuota.
   */
  findOrphanAccessoriesOnDelete(productIndex: number): { product: any; index: number; line: any }[] {
    if(!this.list_product || !this.lines_mapping) return [];
    const target = this.list_product[productIndex];
    if(!target || (target as any).type !== 1) return [];
    const targetType = (target as any).type_trackerGps;
    if(targetType === undefined || targetType === null) return [];

    /* Tipi tracker che resterebbero in carrello dopo l'eliminazione. */
    const remainingTypes = new Set<number>();
    this.list_product.forEach((p, i) => {
      if(i === productIndex) return;
      if(!this.lines_mapping[i]) return;
      if((p as any).type !== 1) return;
      const t = (p as any).type_trackerGps;
      if(t !== undefined && t !== null) remainingTypes.add(Number(t));
    });

    /* Accessori in carrello che dipendono dal tracker eliminato e che NON
       sono compatibili con nessun altro tracker rimasto. */
    const orphans: { product: any; index: number; line: any }[] = [];
    this.list_product.forEach((p, i) => {
      if((p as any).type !== 2) return;
      const line = this.lines_mapping[i];
      if(!line) return;
      const associations: any[] = Array.isArray((p as any).type_trackerGps_associato)
        ? (p as any).type_trackerGps_associato
        : [];
      if(!associations.length) return;

      const matchesDeleted = associations.some(a => Number(a?.type_trackerGps) === Number(targetType));
      if(!matchesDeleted) return;

      const stillSupported = associations.some(a => {
        const t = a?.type_trackerGps;
        return t !== undefined && t !== null && remainingTypes.has(Number(t));
      });
      if(stillSupported) return;

      orphans.push({ product: p, index: i, line });
    });
    return orphans;
  }

  /**
   * Pallino arancione sul tab "Accessori" quando l'utente ha un tracker
   * compatibile in carrello ma manca almeno uno degli accessori suggeriti.
   * Memoizzato.
   */
  showAccessoryNudge(): boolean {
    this.ensureMemo();
    if(this._memoNudge !== null) return this._memoNudge;
    const items = this._memoUpsell || [];
    let any = false;
    for(let i = 0; i < items.length; i++){
      if(items[i].qty === 0){ any = true; break; }
    }
    this._memoNudge = items.length > 0 && any;
    return this._memoNudge;
  }

  /**
   * Modifica la quantità di uno stub debug (chiamato dal componente per i
   * chip non agganciati al backend). Δ può essere -1 / +1 / qualsiasi delta.
   */
  setStubQuantity(index: number, delta: number){
    const next = Math.max(0, (this._stub_qty[index] || 0) + delta);
    this._stub_qty[index] = next;
    ViewService.updateView.next(undefined);
  }

  /**
   * True se il reminder di upsell deve essere visualizzato:
   * almeno un accessorio compatibile esiste e non è ancora stato aggiunto al carrello.
   */
  showUpsellReminder(): boolean {
    /* Il design tiene il reminder visibile anche quando tutti gli accessori
       sono già stati aggiunti, perché lo stepper resta utile per regolare
       la quantità. Quindi mostriamo finché ci sono items da proporre. */
    const items = this.getUpsellAccessories();
    return items.length > 0;
  }

  /**
   * Estrae la descrizione del prodotto come stringa, supportando sia il formato
   * stringa diretta che il formato oggetto multilingua { it: ..., en: ... }.
   */
  private getProductDescriptionAsString(p: any): string {
    const d = p?.description;
    if(!d) return '';
    if(typeof d === 'string') return d;
    if(typeof d === 'object'){
      const lang = this.data?.selOrganization?.translate_language;
      return d[lang] || d['it'] || d['en'] || (Object.values(d).find(v => typeof v === 'string') as string) || '';
    }
    return '';
  }

}
